import PropTypes from "prop-types";
import Pill from "../Pill";

const CategoryLinksList = ({ links }) => (
  <>
    {links.map(({ friendlyName, linkUrl, isCurrentCategory }) => (
      <Pill
        key={friendlyName}
        friendlyName={friendlyName}
        linkUrl={linkUrl}
        isHighlighted={isCurrentCategory}
      />
    ))}
  </>
);

CategoryLinksList.propTypes = {
  links: PropTypes.arrayOf(
    PropTypes.shape({
      friendlyName: PropTypes.string.isRequired,
      linkUrl: PropTypes.string.isRequired,
      isCurrentCategory: PropTypes.bool
    })
  ).isRequired
};

export default CategoryLinksList;
